import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { helper } from 'src/environments/helper';
import { MatDialog } from '@angular/material/dialog';
import { NewDestinationComponent } from './add-new-destination/new-destination.component';
import { DocumentIesireComponent } from '../../doc-iesire/document-iesire.component';
import { DocumentData, DocumentActivity, GeneralData, EmailDocument, StoreDocResponse } from '../../document.interface';
import { OpenEmailComponent } from './open-email/open-email.component';
import { DocIntrareComponent } from '../../doc-intrare/doc-intrare.component';
import { DocumentInternComponent } from '../../doc-intern/document-intern.component';
import { PermissionsService } from 'src/app/services/permissions.service';
import Swal from 'sweetalert2';
import { ModalFinalizareActivityComponent } from './../modal-finalizare-activity/modal-finalizare-activity.component';
import { PreluareNrRegistruComponent } from './../preluare-nr-registru/preluare-nr-registru.component';
import { DialogService } from 'src/app/services/dialog.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-activitate-flux-actiuni-operator',
    templateUrl: './activitate-flux-actiuni-operator.component.html',
    styleUrls: ['./activitate-flux-actiuni-operator.component.scss'],
})
export class ActivitateFluxActiuniOperatorComponent {
    @Input() docData!: DocumentData;
    @Input() activityData!: DocumentActivity[];
    @Input() childrenData!: any[];
    @Input() generalData!: GeneralData[];
    @Output() docChanged: EventEmitter<void> = new EventEmitter();
    @Input() activeAccess!: any;
    @Input() currentUser!: any;

    helper = helper;
    isLoading: boolean = false;

    registruOficialValue: string | null = null;

    constructor(
        public dashboardService: DashboardService,
        public dialog: MatDialog,
        private permissionsService: PermissionsService,
        private dialogService: DialogService,
        private toastService: ToastService,
    ) { 
        setTimeout(() => {
            console.log('Current User:', this.currentUser);
            console.log('Active Access:', this.activeAccess);
            console.log('Document general:', this.generalData);
            this.registruOficialValue = this.generalData.find(item => item.name === "registru_oficial")?.value ?? null;
            console.log('Registru Oficial Value:', this.registruOficialValue);
        }, 200)
    }

    openAddNewDestinationDialog(): void {
        const dialogRef = this.dialog.open(NewDestinationComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: this.docData,
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.docChanged.emit();
            }
        });
    }

    openInNewTab(idDocument: number) {
        const url = `#/documente?id=${idDocument}`;
        window.open(url, '_blank');
    }

    openAddDialogIntrare(serieId: number, reg_number: string | null, idDocumentActivity: number| null) {
        const dialogRef = this.dialog.open(DocIntrareComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                reg_number: reg_number,
                serieId: serieId,
                idDocumentActivity: idDocumentActivity
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse}) => {
            if (success) {
                this.docChanged.emit();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openAddDialogIntern(serieId: number, reg_number: string | null, idDocumentActivity: number| null) {
        const dialogRef = this.dialog.open(DocumentInternComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                reg_number: reg_number,
                serieId: serieId,
                idDocumentActivity: idDocumentActivity
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse}) => {
            if (success) {
                this.docChanged.emit();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    // typeDoc info
    // 1 => new number for document, indiferent de natura lui
    // 2 => transfer document catre o alta entitate.. dar preia acelasi numar!!! (DGITL)
    // 3 => restituire, catre emitent cu un raspuns. Asta inseamna ca avem anumite formalitati noi!!! (DGITL)
    openAddDialogIesire(typeDoc: number = 1, serieId: number, reg_number: string | null, idDocumentActivity: number| null) {
        const dialogRef = this.dialog.open(DocumentIesireComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                reg_number: reg_number,
                serieId: serieId,
                typeDoc: typeDoc,
                idDocumentActivity: idDocumentActivity
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse}) => {
            if (success) {
                this.docChanged.emit();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    removeDocumentActivity(activityId: number) { 
        console.log('Removing document activity with ID:', activityId);
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați procedura de indepartare a documentului din cadrul unui borderou/activitate',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.dashboardService
                    .removeActivity(activityId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {

                    // success, refresh document please
                    this.docChanged.emit();

                });
            }
        });
    }



    openEmail(email: EmailDocument) {
        const dialogRef = this.dialog.open(OpenEmailComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                emailData: email,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) { }
        });
    }

    compareNumbers(number1: number, number2: number) {
        return (number1 === number2 ? true : false);
    }

    checkPermissionFromView(slug: string) {
        return this.permissionsService.hasPermission(slug);
    }

    preluareDocumentInLucru(activityId: number) {
        console.log('Preluare document in lucru for activity ID:', activityId);

        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați doar dacă ați primit documentația!',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: () => {
                return this.dashboardService
                    .preluareActivity(activityId)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = this.helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    // success, refresh document please
                    this.docChanged.emit();
                });
            }
        });


    }

    preluareNumarRegistru(activityId: number) {
        this.isLoading = true;
        console.log('Preluare numar registru for activity ID:', activityId);
        const dialogRef = this.dialog.open(PreluareNrRegistruComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                activityId: activityId
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.docChanged.emit();
            }
        });
    }

    finalizareDocumentInLucru(activityId: number) {
        this.isLoading = true;
        console.log('Finalizare document in lucru for activity ID:', activityId);

        let dialogRef = this.dialog.open(ModalFinalizareActivityComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                activityId: activityId
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                // success, refresh document please
                this.docChanged.emit();
            }
        });
    }

    rollBackDocumentInLucru(activityId: number) {
        this.isLoading = true;
        console.log('Roll back document in lucru for activity ID:', activityId);
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați procedura de RollBack/anulare a finalizării de document',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.dashboardService
                    .rollBackFinalizareActivity(activityId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {

                    // success, refresh document please
                    this.docChanged.emit();

                });
            }
        });
    }
    
    rollPreluareDocumentInLucru(activityId: number) {
        this.isLoading = true;
        console.log('Roll preluare document in lucru for activity ID:', activityId);
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați procedura de RollBack a preluării de document',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.dashboardService
                    .rollBackPreluareActivity(activityId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {

                    // success, refresh document please
                    this.docChanged.emit();

                });
            }
        });
    }

    updateFormular(idDocument: number) {

        this.isLoading = true;
        console.log('Update formular for document ID:', idDocument);
    }
}
